import { render } from "./ClassIntro.vue?vue&type=template&id=37fb95a5&scoped=true"
import script from "./ClassIntro.vue?vue&type=script&lang=ts"
export * from "./ClassIntro.vue?vue&type=script&lang=ts"

import "./ClassIntro.vue?vue&type=style&index=0&id=37fb95a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37fb95a5"

export default script